<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Edit Student">
      <div class="row">
        <div class="col-md-6 form-group">
          User Name
          <input
            class="form-control"
            type="text"
            v-model="username"
            @focus="usernameEmpty = false"
          />
          <div v-if="usernameEmpty" style="color: red">
            UserName is required
          </div>
        </div>
        <div class="col-md-6 form-group">
          Mobile
          <input
            class="form-control"
            v-model="moblie"
            @focus="moblieEmpty = false"
            type="number"
          />
          <div v-if="moblieEmpty" style="color: red">
            Mobile is required
          </div>
        </div>
        <div class="col-md-6 form-group">
          Email
          <input
            class="form-control"
            v-model="email"
            @focus="emailEmpty = false"
            type="text"
          />
          <div v-if="emailEmpty" style="color: red">
            Email is required
          </div>
        </div>
        <div class="col-md-6 form-group">
          Registration Number
          <input
            class="form-control"
            v-model="req_no"
            @focus="req_noEmpty = false"
            type="text"
          />
          <div v-if="req_noEmpty" style="color: red">
            Registration Number is required
          </div>
        </div>
      </div>
      <div class="text-center mt-5 mb-3">
        <b-button
          class="text-center pt-2 pb-2 pr-4 pl-4"
          variant="success"
          style="margin-bottom: 20px;"
          @click="save()"
          >Save</b-button
        >
      </div>
    </base-block>
    <!-- Loader -->
    <b-overlay
      :show="loader"
      no-wrap
      blur="2px"
      opacity="0.60"
      class="position-fixed"
    >
      <template #overlay>
        <i class="fa fa-3x fa-cog fa-spin text-primary"></i>
      </template>
    </b-overlay>
    <!-- End Loader -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      username: "",
      usernameEmpty: false,
      moblie: "",
      moblieEmpty: false,
      email: "",
      emailEmpty: false,
      req_no: "",
      req_noEmpty: false,
      clg_name: "",
      clg_nameEmpty: false,
      user_detail: {},
      loader: false,
    };
  },
  mounted() {
    this.getUser();
  },
  methods: {
    async getUser() {
      this.loader = true;
      await axios
        .get(
          `${this.$store.getters.baseUrl}/college_users_detail/${this.$route.params.userId}`,
          {
            headers: {
               Authorization: `Bearer ${this.$store.getters.collegeToken}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          this.loader = false;
          if (response.data.status == "success") {
            let data = response.data.user_detail;
            this.username = data.name;
            this.moblie = data.mobile;
            this.email = data.email;
            this.req_no = data.registration_number;
            this.user_detail = data;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          this.loader = false;
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async save() {
      if (this.username == "") {
        this.usernameEmpty = true;
        return;
      }

      if (this.moblie == "") {
        this.moblieEmpty = true;
        return;
      }

      if (this.email == "") {
        this.emailEmpty = true;
        return;
      }

      if (this.req_no == "") {
        this.req_noEmpty = true;
        return;
      }

      const formdata = new FormData();
      formdata.append("name", this.username);
      formdata.append("mobile", this.moblie);
      formdata.append("email", this.email);
      formdata.append("registration_number", this.req_no);

      this.loader = true;
      await axios
        .post(
          `${this.$store.getters.baseUrl}/college_userdetails_update/${this.$route.params.userId}`,
          formdata,
          {
            headers: {
               Authorization: `Bearer ${this.$store.getters.collegeToken}`,
            },
          }
        )
        .then((response) => {
          this.loader = false;
          if (response.data.status == "success") {
            console.log(response);
            this.$swal("Success", "User Updated successfully", "success");
            this.$router.push(
              `/backend/tables/college/${localStorage.getItem(
                "collegeUrl"
              )}/students`
            );
            this.username = "";
            this.email = "";
            this.moblie = "";
            this.req_no = "";
            this.clg_name = "";
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          this.loader = false;
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  },
};
</script>
